import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { CRUDModes } from '../../../../../interfaces/CRUD';
import DialogCustomTitle from '../../../../../components/DialogCustomTitle/DialogCustomTitle';
import SponsorForm from '../../SponsorForm/SponsorForm';
import { SponsorsTableEntry } from '../../../Interfaces/Sponsors';

export interface SponsorsFormProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  mode: CRUDModes;
  onSuccess: () => void;
  values?: SponsorsTableEntry;
  closeFunction?: () => void;
}

const SponsorsPopupForm = ({
  open,
  setOpen,
  mode,
  onSuccess,
  values,
  closeFunction,
}: SponsorsFormProps): JSX.Element => {
  return (
    <Dialog
      maxWidth='xl'
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
          if (closeFunction) closeFunction();
        }
      }}
    >
      <DialogCustomTitle
        onClose={() => {
          setOpen(false);
          if (closeFunction) closeFunction();
        }}
        mode={mode}
        title='patrocinador'
      />
      <DialogContent>
        {open ? (
          <SponsorForm
            onSuccess={() => {
              setOpen(false);
              if (closeFunction) closeFunction();
              onSuccess();
            }}
            mode={mode}
            values={values}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default SponsorsPopupForm;
